/**
 * Representa os tipos de alvo para aplicação ou remoção em lote de adicionais.
 */
export enum EAdditionalApplyTargetType {
  AllProducts,
  SelectedProducts,
  AllCatalogItems,
  SelectedCatalogItems,
  AllCombos,
  SelectedCombos,
}
